import { render, staticRenderFns } from "./SchoolEducationalFields.vue?vue&type=template&id=894790ac"
import script from "./SchoolEducationalFields.vue?vue&type=script&lang=js"
export * from "./SchoolEducationalFields.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports